angular.module("ainapp")
    .controller("billAdjustmentReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Bill Adjustment Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.ParentList = [];
            MainService.GetCustomerParentList().then(function (response) {
                $scope.ParentList = response.data;
            });

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })



            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    BranchId: "",
                    AccountParentId: "",
                    VoucherNo: "",
                    CustomerIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();



            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.accountInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };






            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {


                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            o.data.FromYear = $scope.filter.FromDate.getFullYear();

                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            o.data.ToYear = $scope.filter.ToDate.getFullYear();

                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            o.data.BranchId = $scope.filter.BranchId;
                            o.data.AccountParentId = $scope.filter.AccountParentId;

                            MainService.BillWiseAnalysisReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }



                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.BalanceAmount.count = 0;
                        angular.forEach(data.items, function (a) {
                            a.aggregates.BalanceAmount.count = Math.abs(a.aggregates.Debit.sum - a.aggregates.Credit.sum);
                            a.aggregates.BalanceAmount.count = Math.round(a.aggregates.BalanceAmount.count * 100) / 100;
                        })
                        data.sender._aggregateResult.BalanceAmount.count = Math.abs(data.sender._aggregateResult.Debit.sum - data.sender._aggregateResult.Credit.sum);
                        data.sender._aggregateResult.BalanceAmount.count = Math.round(data.sender._aggregateResult.BalanceAmount.count * 100) / 100;
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "BillWiseAnalysis.INVNo": {
                                type: "string",
                                editable: false,
                            },
                            "BillWiseAnalysis.INVType": {
                                type: "string",
                                editable: false,
                            },
                            "BillWiseAnalysis.TotalAmount": {
                                type: "number",
                                editable: false,
                            },
                            "BillWiseAnalysis.TotalPaid": {
                                type: "number",
                                editable: false,
                            },
                            "BillWiseAnalysis.BalanceAmount": {
                                type: "number",
                                editable: false,
                            },
                            "BillWiseAnalysis.Date": {
                                type: "date",
                                editable: false,
                            },
                            "BillWiseAnalysis.Account.Name": {
                                type: "string",
                                editable: false,
                            },


                            ReceiptNo: {
                                type: "string",
                                editable: false,
                            },
                            ReceiptType: {
                                type: "string",
                                editable: false,
                            },
                            Credit: {
                                type: "number",
                                editable: false,
                            },
                            Debit: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },



                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,

                group: [{
                    field: "BillWiseAnalysis.Account.Name",
                    aggregates: [{
                        field: "Debit",
                        aggregate: "sum"
                        }, {
                        field: "Credit",
                        aggregate: "sum"
                        }, {
                        field: "BalanceAmount",
                        aggregate: "count"
                        }]
                    }],

                aggregate: [


                    {
                        field: "Debit",
                        aggregate: "sum"
                        }, {
                        field: "Credit",
                        aggregate: "sum"
                        },
                    {
                        field: "BalanceAmount",
                        aggregate: "count"
                        }



                    ],
                sort: [{
                    field: "BillWiseAnalysis.Id",
                    dir: "asc"
                    }, {
                    field: "Id",
                    dir: "asc"
                    }]
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "BillWiseAnalysis.INVNo",
                        title: "INV No",
                        width: "100px",
                        hidden: true,
                        },
                    {
                        field: "BillWiseAnalysis.Account.Name",
                        title: "Account",
                        width: "100px",
                        hidden: true,
                        },
                    {
                        field: "BillWiseAnalysis.Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(BillWiseAnalysis.Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        hidden: true,
                        },

                    {
                        field: "BillWiseAnalysis.INVType",
                        title: "Type",
                        width: "100px",
                        hidden: true,
                        },
                    {
                        field: "BillWiseAnalysis.TotalAmount",
                        title: "Total Amount",
                        width: "100px",
                        hidden: true,
                        },
                    {
                        field: "BillWiseAnalysis.TotalPaid",
                        title: "Total Paid",
                        width: "100px",
                        hidden: true,
                        },

                    {
                        field: "ReceiptType",
                        title: "Rec Type",
                        width: "100px",
                        },
                    {
                        field: "ReceiptNo",
                        title: "Rec No",
                        width: "100px",
                        },

                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
                    {
                        field: "Debit",
                        title: "Debit",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Debit</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        //  footerTemplate: "#=kendo.toString(sum, '0.00')#",
                        },
                    {
                        field: "Credit",
                        title: "Credit",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Credit</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        // footerTemplate: "#=kendo.toString(sum, '0.00')#",
                        },
                    {
                        field: "BalanceAmount",
                        title: "Balance",
                        template: "<div></div>",
                        width: "100px",
                        // hidden: true,
                        headerTemplate: kendo.template("<div class='headerright'>Balance</div>"),
                        groupFooterTemplate: "#=kendo.toString(count, '0.00')#",
                        //   footerTemplate: "#=kendo.toString(sum, '0.00')#",

                        },

                        ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                MainService.PrintCPVMasterReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


            }])
